import i18n from "lib/i18n"
import $ from "jquery"
import defer from "lodash/defer"
import template from "lodash/template"
import { View } from "backbone"

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Represents a toggleable menu, with a consistent HTML interface:
// - an element (preferably an anchor), with class "menu-button"
// - an element (preferably an unordered list), with class "menu"
let TopbarToggleMenu
export default TopbarToggleMenu = (function () {
  TopbarToggleMenu = class TopbarToggleMenu extends View {
    static initClass() {
      this.prototype.menuClose = template(
        "\
<button type='button' class='menu-button-close'><%- i18n.t(\"top_bar.close_menu\") %></button>\
",
        { imports: { i18n } },
      )
    }

    initialize(options) {
      this.menuVisibilityClassName = `${options.selector.substring(1)}-open`
      this._openMenu = this._openMenu.bind(this)
      this._closeMenu = this._closeMenu.bind(this)
      this._documentClickHandler = this._documentClickHandler.bind(this)
      this._keydownHandler = this._keydownHandler.bind(this)
      if (options == null) {
        options = {}
      }
      this.menuButtonOpen = this.$el.find(".menu-button-open")
      this.menuButtonOpen.show()
      this.menuButtonOpen.on("click", this._openMenu)

      return super.initialize(options)
    }

    _openMenu(event) {
      event.preventDefault()

      // We must lift the "state" of this object outside it's own
      // dom tree, because this dom tree can potentially be
      // completely replaced by "dynamic content".
      //
      // The reasons this is important are because if a user has
      // the menu open, and this state is not lifted out, it will
      // be lost when the topbar dom tree is replaced.
      //
      // This is bad for users, but it's especially bad for our
      // acceptance specs.
      //
      // It's absolutely terrible, but we will make it better I
      // promise!
      $("body").addClass(this.menuVisibilityClassName)

      // We rely on these document click events to close the menu
      defer(() => $(document).on("click", this._documentClickHandler))
      defer(() => $(document).on("keydown", this._keydownHandler))
    }

    _closeMenu(event) {
      if (event != null) {
        event.preventDefault()
      }

      // We must lift the "state" of this object outside it's own
      // dom tree, because this dom tree can potentially be
      // completely replaced by "dynamic content".
      //
      // The reasons this is important are because if a user has
      // the menu open, and this state is not lifted out, it will
      // be lost when the topbar dom tree is replaced.
      //
      // This is bad for users, but it's especially bad for our
      // acceptance specs.
      //
      // It's absolutely terrible, but we will make it better I
      // promise!
      $("body").removeClass(this.menuVisibilityClassName)

      // We rely on these document click events to close the menu
      defer(() => $(document).off("click", this._documentClickHandler))
      defer(() => $(document).off("keydown", this._keydownHandler))
    }

    _documentClickHandler(event) {
      event.stopPropagation()
      return this._closeMenu()
    }

    _keydownHandler(event) {
      const menuItems = this.$el.find(".menu li a")
      const currentFocused = menuItems.index($(document.activeElement))

      const keyHandlers = {
        Escape: { keyCode: 27, handler: (ev) => this._handleEscape(ev) },
        ArrowDown: {
          keyCode: 40,
          handler: (ev) => this._handleArrowDown(ev, menuItems, currentFocused),
        },
        ArrowUp: {
          keyCode: 38,
          handler: (ev) => this._handleArrowUp(ev, menuItems, currentFocused),
        },
        Tab: { keyCode: 9, handler: (ev) => this._handleTab(ev, menuItems, currentFocused) },
        " ": { keyCode: 32, handler: (ev) => this._handleSpace(ev) },
      }

      const keyHandler =
        keyHandlers[event.key] ||
        Object.values(keyHandlers).find((h) => h.keyCode === event.keyCode)
      keyHandler?.handler(event)
    }

    _handleEscape(event) {
      event.preventDefault()
      this.menuButtonOpen?.focus()
      this._closeMenu()
    }

    _handleArrowDown(event, menuItems, currentFocused) {
      event.preventDefault()
      const nextIndex = Math.min(currentFocused + 1, menuItems.length - 1)
      menuItems.eq(nextIndex)?.focus()
    }

    _handleArrowUp(event, menuItems, currentFocused) {
      event.preventDefault()
      const prevIndex = Math.max(currentFocused - 1, 0)
      menuItems.eq(prevIndex)?.focus()
    }

    _handleSpace(event) {
      const focusedItem = $(document.activeElement)
      if (focusedItem.closest(".menu").length > 0) {
        event.preventDefault()
        focusedItem?.[0]?.click()
      }
    }

    _handleTab(event, menuItems, currentFocused) {
      const isLastItem = currentFocused === menuItems.length - 1
      const isFirstItem = currentFocused === 0
      const isShiftKey = event.shiftKey
      const shouldCloseViaTop = isShiftKey && (isFirstItem || currentFocused === -1)
      const shouldCloseViaBottom = !isShiftKey && isLastItem

      if (shouldCloseViaTop || shouldCloseViaBottom) {
        event.preventDefault()
        this.menuButtonOpen.focus()
        this._closeMenu()
      }
    }
  }
  TopbarToggleMenu.initClass()
  return TopbarToggleMenu
})()
